var _rect, _rect2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImmediateOrderBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 24,
    viewBox: "0 0 66 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 24,
    rx: 4,
    fill: "#49C5C4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5313_16967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5313_16967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69702 4.66663C8.38618 4.66663 8.1166 4.88144 8.04718 5.18442L6.35021 12.5918C6.30489 12.7897 6.35217 12.9974 6.47866 13.1561C6.60515 13.3149 6.79707 13.4074 7.00005 13.4074H9.14469L8.04521 18.5266C7.9805 18.828 8.13076 19.1344 8.40863 19.2677C8.6865 19.401 9.01953 19.3265 9.21408 19.0874L16.8504 9.70473C17.0128 9.50519 17.0459 9.23 16.9355 8.99764C16.825 8.76529 16.5907 8.61724 16.3334 8.61724H13.7645L14.4397 5.47328C14.482 5.27639 14.433 5.07093 14.3065 4.91429C14.1799 4.75766 13.9893 4.66663 13.7879 4.66663H8.69702Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1616 5.98047V18H30.4849L24.3921 9.21777H24.2925V18H22.4663V5.98047H24.1597L30.2524 14.7793H30.3687V5.98047H32.1616ZM45.061 11.9902C45.061 15.8252 42.7534 18.166 39.6489 18.166C36.5112 18.166 34.2202 15.8252 34.2202 11.9902C34.2202 8.13867 36.5112 5.81445 39.6489 5.81445C42.7534 5.81445 45.061 8.13867 45.061 11.9902ZM43.2515 11.9902C43.2515 9.06836 41.7075 7.49121 39.6489 7.49121C37.5737 7.49121 36.0298 9.06836 36.0298 11.9902C36.0298 14.9121 37.5737 16.4893 39.6489 16.4893C41.7075 16.4893 43.2515 14.9121 43.2515 11.9902ZM49.3276 18L45.9907 5.98047H47.9165L50.2573 15.2773H50.3569L52.7974 5.98047H54.6899L57.1304 15.2773H57.23L59.5708 5.98047H61.4966L58.1597 18H56.3169L53.7935 9.01855H53.6938L51.1704 18H49.3276Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmediateOrderBadge);
export default __webpack_public_path__ + "static/media/immediateOrderBadge.76e1d94c13ea4ff87949960151c781f5.svg";
export { ForwardRef as ReactComponent };